"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionsFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../composite/evidence/dictionary-evidence/dictionary-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const actions_fields_1 = require("./actions-fields");
const actions_columns_1 = require("./actions-columns");
const actions_schema_1 = require("./actions-schema");
function actionsFactory(url, reportTag, defaultSorts) {
    return function Actions() {
        const intl = react_intl_1.useIntl();
        const validationSchema = actions_schema_1.useValidationSchema();
        const evidence = dictionary_evidence_1.useDictionaryEvidence({
            identifier: 'ACTIONS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: actions_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_ACTIONS_TABLE_TITLE',
                    defaultMessage: 'Skripty',
                }),
                reportTag,
                defaultSorts,
            },
            detailProps: {
                FieldsComponent: actions_fields_1.ActionsFields,
                validationSchema,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.actionsFactory = actionsFactory;
//# sourceMappingURL=actions.js.map